import { Spherical, Vector3 } from "three/webgpu";

export const WORLD_ORIGIN = new Vector3(0, 0, 0);
export const HERO_TARGET = new Vector3(0, 0.15, 0);
export const HERO_RADIUS = 44;
export const HERO_PHI = 1.26;
export const HERO_THETA = -0.18;
export const HERO_POSITION = new Vector3().setFromSpherical(new Spherical(HERO_RADIUS, HERO_PHI, HERO_THETA));

const WORLD_UP = new Vector3(0, 1, 0);
const HERO_FORWARD = HERO_TARGET.clone().sub(HERO_POSITION).normalize();

export const CARTOGRAPHY_NORMAL = HERO_POSITION.clone().sub(HERO_TARGET).normalize();
export const CARTOGRAPHY_RIGHT = new Vector3().crossVectors(HERO_FORWARD, WORLD_UP).normalize();
export const CARTOGRAPHY_UP = new Vector3().crossVectors(CARTOGRAPHY_RIGHT, HERO_FORWARD).normalize();
export const CARTOGRAPHY_SCALE = 2.25;
export const CARTOGRAPHY_DEPTH_SCALE = 0.72;

export function projectCartographyPositionInto(position: readonly [number, number, number], target: Vector3) {
  const [u, v, depth] = position;
  return target
    .copy(WORLD_ORIGIN)
    .addScaledVector(CARTOGRAPHY_RIGHT, u * CARTOGRAPHY_SCALE)
    .addScaledVector(CARTOGRAPHY_UP, v * CARTOGRAPHY_SCALE)
    .addScaledVector(CARTOGRAPHY_NORMAL, depth * CARTOGRAPHY_SCALE * CARTOGRAPHY_DEPTH_SCALE);
}

export function projectCartographyPosition(position: readonly [number, number, number]) {
  return projectCartographyPositionInto(position, new Vector3());
}

export function decomposeWorldPositionToCartography(position: Vector3, target: Vector3) {
  return target.set(position.dot(CARTOGRAPHY_RIGHT), position.dot(CARTOGRAPHY_UP), position.dot(CARTOGRAPHY_NORMAL));
}

export function composeWorldPositionFromCartography(x: number, y: number, z: number, target: Vector3) {
  return target
    .copy(WORLD_ORIGIN)
    .addScaledVector(CARTOGRAPHY_RIGHT, x)
    .addScaledVector(CARTOGRAPHY_UP, y)
    .addScaledVector(CARTOGRAPHY_NORMAL, z);
}

export function projectVectorToCartographyPlane(vector: Vector3, target: Vector3) {
  return target.copy(vector).addScaledVector(CARTOGRAPHY_NORMAL, -vector.dot(CARTOGRAPHY_NORMAL));
}
